import { render, staticRenderFns } from "./MessageItemFooter.vue?vue&type=template&id=771e0d91&scoped=true&"
import script from "./MessageItemFooter.vue?vue&type=script&lang=ts&"
export * from "./MessageItemFooter.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "771e0d91",
  null
  
)

export default component.exports